import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { AuthShell } from "../components/AuthShell";
import { publicApi, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function GoogleConsent() {
  const { state } = useLocation();
  const nav = useNavigate();
  const { loginParent } = useAuth();
  const [f, setF] = useState({ is_adult: false, consent: false });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (!state?.ticket) return <Navigate to="/signup" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await publicApi.post("/auth/google/complete", { ticket: state.ticket, ...f });
      loginParent(data);
      nav("/parent", { replace: true });
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };

  return (
    <AuthShell testid="google-consent">
      <ShieldCheck size={36} />
      <h1 className="text-3xl font-bold">One last step, {state.name}</h1>
      <p className="text-[#1B1A2E]/70">You're creating a Zunii family account for <b data-testid="google-consent-email">{state.email}</b>.</p>
      <form onSubmit={submit} className="space-y-4 text-sm">
        <label className="flex gap-3 items-start cursor-pointer">
          <input data-testid="google-adult-checkbox" type="checkbox" className="mt-1 w-5 h-5 accent-[#7B5CFA]" checked={f.is_adult} onChange={(e) => setF({ ...f, is_adult: e.target.checked })} />
          <span>I'm a parent or legal guardian and I'm 18 or older.</span>
        </label>
        <label className="flex gap-3 items-start cursor-pointer">
          <input data-testid="google-consent-checkbox" type="checkbox" className="mt-1 w-5 h-5 accent-[#7B5CFA]" checked={f.consent} onChange={(e) => setF({ ...f, consent: e.target.checked })} />
          <span>I agree to the <Link to="/terms" className="underline font-semibold">Terms</Link> and <Link to="/privacy" className="underline font-semibold">Privacy Policy</Link>, and I consent to my child using Zunii under my supervision.</span>
        </label>
        {err && <p data-testid="google-consent-error" className="text-[#E8442A] font-semibold">{err}</p>}
        <button data-testid="google-consent-submit" disabled={busy || !(f.is_adult && f.consent)} className="zn-btn bg-[#FF6B4A] text-white w-full text-lg">{busy ? "One sec…" : "Create family account"}</button>
        <Link to="/login" data-testid="google-consent-cancel" className="block text-center font-semibold underline">Cancel</Link>
      </form>
    </AuthShell>
  );
}
